<div class="page-wrapper customer-page-wrapper">
  <dx-load-panel
    [hideOnOutsideClick]="false"
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loadingIndicator">
  </dx-load-panel>
  <div fxLayout="column">
      <div class="flex-p">
        <div class="card">
          <div class="card-header justify-space-between d-flex align-items-center cursor-pointer">
            <h5 class="m-0"> Customers</h5>
            <div class="cursor-pointer" >
              <button style="height: 30px;line-height: 30px;"  mat-icon-button (click)="addFilter()" UserAccessibility="canAdd">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div fxLayout="column">
    <div class="flex-p">
      <mat-card class="custom-card">
        <!-- <mat-card-header class="bg-primary p-1" fxLayoutAlign="space-between center">
          <mat-card-title class="m-0"><h3>Customer</h3></mat-card-title>
          <button mat-icon-button (click)="addFilter()" UserAccessibility="canAdd"><mat-icon>add</mat-icon></button>
        </mat-card-header> -->
        <mat-card-content>
          <div class="remove-side-spacing">
            <!-- <mat-progress-bar mode="indeterminate" *ngIf="loadingIndicator" class="mt-1"></mat-progress-bar> -->
            <dx-data-grid 
              id="gridContainer10" 
              [dataSource]="rows"  
              keyExpr="customerId"          
              [columnAutoWidth]="true" 
              [showBorders]="true">
              <dxo-paging [pageSize]="10"></dxo-paging>
              <dxo-pager 
                [showPageSizeSelector]="true"
                [allowedPageSizes]="[5, 10, 20]"
                [showInfo]="true">
              </dxo-pager>
              <dxo-filter-row [visible]="true" ></dxo-filter-row>
              <!-- <dxo-search-panel [visible]="true"></dxo-search-panel> -->

              <!-- <dxo-group-panel [visible]="true"></dxo-group-panel>
              <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping> -->
              <!-- <dxo-filter-row
                      [visible]="true"
              ></dxo-filter-row> -->
              <!-- <dxo-header-filter
                      [visible]="true"></dxo-header-filter> -->

              <!-- <dxo-export [enabled]="true" fileName="AllCustomers" [allowExportSelectedData]="false"></dxo-export> -->
              <dxi-column dataField="customerId" cssClass="text-center" caption="ID"  [width]="100"></dxi-column>
              <dxi-column dataField="customerName"  caption="Name"></dxi-column>
              <dxi-column dataField="arabicCustomerName"  caption="Arabic Name"></dxi-column>
              <!-- <dxi-column dataField="postalAddress" caption="Postal Address"  cssClass="text-center"></dxi-column>
              <dxi-column dataField="postalAddressArabic" caption="Arabic Postal Address" cssClass="text-center"></dxi-column> -->
              <dxi-column dataField="customerCRNO" caption="CRNO" [width]="130" cssClass="text-center"></dxi-column>
              <dxi-column dataField="countryName" caption="Country"  cssClass="text-center"></dxi-column>
              <!-- <dxi-column dataField="provenceName" caption="Province Name" cssClass="text-center"></dxi-column>
              <dxi-column dataField="cityName" caption="City Name" cssClass="text-center"></dxi-column> -->
              <dxi-column dataField="companyBranchCode" caption="Code" cssClass="text-center" [width]="130"></dxi-column>
              <dxi-column dataField="contactNo" caption="Phone #" cssClass="text-center" [width]="130"></dxi-column>
              <dxi-column dataField="emailAddress" caption="Email"  cssClass="text-center" [width]="130"></dxi-column>
              <!-- <dxi-column dataField="CustomerName" [groupIndex]="0"></dxi-column> -->
              <dxi-column dataField="active" caption="Status" [width]="80" cssClass="text-center" cellTemplate="statusTemplate" [allowFiltering]="false"></dxi-column>
              <dxi-column caption="Actions" [width]="100"  cssClass="text-center" cellTemplate="cellTemplate" [allowFiltering]="false"></dxi-column>
              <div class="employee dx-row" *dxTemplate="let d of 'statusTemplate'" >
                <div class="main-row">
                  <span [ngClass]="d.data.active ? 'text-green' : 'text-red'">{{d.data.active ? 'Active'  : 'Inactive'}}</span>
                </div>
              </div>
              <div *dxTemplate="let data of 'cellTemplate'">
                <button  mat-icon-button
                         matTooltip="Edit Item" [routerLink]="[ '/portal/sales/customers/edit/', data.data.customerId ]" UserAccessibility="canModify">
                  <mat-icon color="primary">edit</mat-icon>
                </button>
                <button type="button" mat-icon-button matTooltip="Delete Item" [swal]="deleteSwal" UserAccessibility="canDelete">
                  <mat-icon color="warn">delete</mat-icon>
                </button>
                <swal #deleteSwal title="Are you sure want to delete ?" text="This cannot be undone" type="question"
                      [showCancelButton]="true" [focusCancel]="true"
                      (confirm)="openDialog(data.data.customerId)">
                </swal>
              </div>
              <div *dxTemplate="let rows of 'detail'">
                <!-- <div class="master-detail-caption">{{employee.data.FirstName + " " + employee.data.LastName + "'s Tasks:"}}</div> -->
                <dx-data-grid 
                    [dataSource]="rows.data.customerContacts"
                    [showBorders]="true"
                    [columnAutoWidth]="true">
                      <dxi-column dataField="contactName"></dxi-column>
                      <dxi-column dataField="departmentName"></dxi-column>
                      <dxi-column dataField="designationName"></dxi-column>
                      <dxi-column dataField="emailAddress"></dxi-column>
                      <dxi-column dataField="mobileNumber"></dxi-column>
                      <dxi-column dataField="phoneNumber"></dxi-column>
                      <dxi-column dataField="emailAddress"></dxi-column>
                </dx-data-grid>       
              </div>
            </dx-data-grid>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
